const SUMMARY_TIMEOUT_MS = 2 * 60 * 1000;

export default SUMMARY_TIMEOUT_MS;
